import { sendSessionEv } from "../../api/events";
import { errorDefinitions } from "./definitions";
import NiceModal from "@ebay/nice-modal-react";

export function showErrorPopup(data, code, details) {
  if (data && code) data.code = code;
  if (data && details) data.details = details
  if (!data) {
    data = translateError();
  }
  NiceModal.show("error-modal", { ...data });
}

export const translateError = error => {
  let errorDetails = {};

  if(error) {
    sendSessionEv("error_occured", error)
  }

  if (error) {
    errorDetails =
      errorDefinitions.filter((el) => { return el.ident === error })[0] ||
      errorDefinitions.filter((el) => { return el.ident === "generic" })[0];
  } else {
    errorDetails = errorDefinitions.filter((el) => { return el.ident === "generic" })[0];
  }

  return errorDetails;
};
